import { render, staticRenderFns } from "./multiItemEditor.vue?vue&type=template&id=0ad54675&scoped=true"
import script from "./multiItemEditor.vue?vue&type=script&lang=js"
export * from "./multiItemEditor.vue?vue&type=script&lang=js"
import style0 from "vue-multiselect/dist/vue-multiselect.min.css?vue&type=style&index=0&prod&lang=css&external"
import style2 from "./multiItemEditor.vue?vue&type=style&index=2&id=0ad54675&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ad54675",
  null
  
)

export default component.exports